import React from "react";
import HomeCarousel from "./Carousels/HomeCarousel/HomeCarousel";
import Card from "./Card/Card";
import OurServices from "./Services/OurServices";
import Portfolio from "./Portfolio/Portfolio";
import AboutUs from "./AboutUs/AboutUs";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import Technologies from "../Technologies/Technologies";
import { FiPhoneCall } from "react-icons/fi";
import { IoLogoWhatsapp } from "react-icons/io";

export default function Home() {
  return (
    <>
      <HomeCarousel />
      <Card />
      <OurServices />
      <Portfolio />
      <Technologies />
      <AboutUs />
      <Contact />
      <hr style={{ border: "1px solid white" }} className="my-0" />
      <Footer />
      {/* Call and WhatsApp */}
      <div className="call">
        <a href="tel:+918538966276" className="tel">
          <FiPhoneCall />
        </a>
        <a href="https://wa.me/918538966276" className="whatsapp">
          <IoLogoWhatsapp />
        </a>
      </div>
    </>
  );
}
